<template>
  <div>
    <div class="d-flex align-center">
      <Icon :icon="paymentIcon" color="systemWalletGreen" class="mr-4" large />
      <Typography variant="subtitle-1">{{ paymentLanguage }}</Typography>
    </div>
    <div
      v-if="showBudgetSelector"
      class="pt-4 d-flex full-width"
      :class="{
        'flex-column align-start': $vuetify.breakpoint.xs,
        'align-center justify-space-between': !$vuetify.breakpoint.xs,
      }"
    >
      <BudgetSelector
        :budgets="budgets"
        :loading="loadingBudgets"
        :value="computedBudgetId"
        @input="computedBudgetId = $event"
        :hide-details="true"
        @blur="$emit('blur')"
        :class="{
          'budget-selector-with-funding': displayBudgetFunding && !$vuetify.breakpoint.xs,
          'full-width': !displayBudgetFunding || $vuetify.breakpoint.xs,
        }"
      />
      <Button
        v-if="displayBudgetFunding"
        @click="$emit('fund-budget')"
        icon-left="mdi-plus"
        outlined
        small
        :class="{
          'ml-4': !$vuetify.breakpoint.xs,
          'mt-4': $vuetify.breakpoint.xs,
        }"
      >
        Add funds
      </Button>
    </div>
    <v-card outlined elevation="0" class="pa-4 mt-4 d-flex justify-space-between align-center">
      <div class="d-flex justify-start align-center lottie-container">
        <div v-if="showStarAnimation" class="lottie-reward-star-effect">
          <LottiePlayer animation="stars" :height="250" :width="250" :speed="1.8" :loop="false" />
        </div>
        <span class="preset-emoji mr-2">{{ emoji }}</span>
        <div class="d-flex flex-column">
          <Typography variant="subtitle-1">
            {{ rewardPresetName || `${paymentLanguage} amount` }}
          </Typography>
          <Typography variant="body-1">
            {{ formatRewardAmount(amount, !paymentPresetId) }}
          </Typography>
        </div>
      </div>
      <div class="d-flex align-center">
        <Button icon @click.stop="$emit('edit')" class="mx-2">
          <v-icon color="black">mdi-pencil-outline</v-icon>
        </Button>
        <Button icon @click.stop="$emit('clear')">
          <v-icon color="black">mdi-trash-can-outline</v-icon>
        </Button>
      </div>
    </v-card>
  </div>
</template>

<script>
import Icon from "@/components/generic/Icon.vue";
import Typography from "@/components/generic/Typography.vue";
import Button from "@/components/generic/Button.vue";
import BudgetSelector from "@/components/budgets/BudgetSelector.vue";
import LottiePlayer from "@/components/LottiePlayer.vue";

import rewardAmountMixin from "@/mixins/rewardAmountMixin.js";
import budgetFundingMixin from "@/mixins/budgetFundingMixin.js";

export default {
  name: "RewardDisplayState",
  mixins: [rewardAmountMixin, budgetFundingMixin],
  components: {
    Icon,
    Typography,
    Button,
    BudgetSelector,
    LottiePlayer,
  },
  props: {
    paymentIcon: {
      type: String,
      default: "mdi-gift-outline",
    },
    paymentLanguage: {
      type: String,
      default: "Reward",
    },
    rewardPresetName: {
      type: String,
      default: null,
    },
    emoji: {
      type: String,
      required: true,
    },
    amount: {
      type: Number,
      required: true,
    },
    paymentPresetId: {
      type: Number,
      default: null,
    },
    cashAward: {
      type: Boolean,
      default: true,
    },
    showBudgetSelector: {
      type: Boolean,
      default: false,
    },
    showFundBudgetButton: {
      type: Boolean,
      default: false,
    },
    budgets: {
      type: Array,
      default: () => [],
    },
    loadingBudgets: {
      type: Boolean,
      default: false,
    },
    budgetId: {
      type: Number,
      default: null,
    },
    showStarAnimation: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    computedBudgetId: {
      get: function () {
        return this.budgetId;
      },
      set: function (newVal) {
        this.$emit("update-budgetId", newVal);
      },
    },
    displayBudgetFunding() {
      return (
        this.showFundBudgetButton &&
        // Checks if Stripe options appear or the manual funding option
        this.hasBudgetFundingOptions(this.selectedBudget)
      );
    },
  },
};
</script>

<style scoped>
.preset-emoji {
  font-size: 32px;
}

.lottie-container {
  position: relative;
}

.lottie-reward-star-effect {
  position: absolute;
  top: -105px;
  left: -105px;
  pointer-events: none;
}

.budget-selector-with-funding {
  max-width: calc(100% - 150px);
}
</style>
